export default __webpack_public_path__ + "static/blob7-f4b4ea47e6c6514e0b675eda4f3c93ce.svg";